import { Reference, useMutation } from '@apollo/client';

import {
  GetJourneyWithPlanQuery,
  TaskCreateDocument,
  TaskCreateMutation,
  TaskCreateMutationVariables,
  TaskFragmentDoc
} from '@typing/Generated';

const useCreateTask = (journey: GetJourneyWithPlanQuery['journey']) => {
  const [createTask] = useMutation<TaskCreateMutation, TaskCreateMutationVariables>(TaskCreateDocument, {
    update: (store, { data }) => {
      if (data?.taskCreate?.task) {
        const newTask = data.taskCreate.task;
        store.modify({
          fields: {
            clientVisibleTasks(cachedTaskRefs: readonly Reference[]) {
              const newTaskRef = store.writeFragment({
                data: newTask,
                fragment: TaskFragmentDoc,
                fragmentName: 'Task'
              });
              if (newTaskRef) {
                return [...cachedTaskRefs, newTaskRef];
              }
              return [...cachedTaskRefs];
            }
          },
          id: store.identify({ ...journey })
        });

        const goals = journey.goals.filter(goal => newTask.goals.some(g => g.id === goal.id));

        goals.map(goal => {
          goal.tasks.map(t => {
            store.modify({
              fields: {
                position() {
                  return t.position + 1;
                }
              },
              id: store.identify({ ...t })
            });
          });
          store.modify({
            fields: {
              tasks(cachedTaskRefs: readonly Reference[]) {
                const newTaskRef = store.writeFragment({
                  data: newTask,
                  fragment: TaskFragmentDoc,
                  fragmentName: 'Task'
                });
                if (newTaskRef) {
                  return [...cachedTaskRefs, newTaskRef];
                }
                return [...cachedTaskRefs];
              }
            },
            id: store.identify({ ...goal })
          });
        });
      }
    }
  });

  return createTask;
};

export default useCreateTask;
